import SidebarHeading from './SidebarHeading';

export default SidebarHeading;
